import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=4c780eae&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=4c780eae&lang=stylus&scoped=true&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c780eae",
  null
  
)

export default component.exports